<template>
  <div class="container__wrapper">
    <topbar>
      <div class="topbar__panel">
        <div class="topbar__heading">
          <h1>Settings</h1>
        </div>
      </div>
      <TopbarPanel>
        <div class="navlinks__item">
          <InertiaLink
            :href="route('settings.application.index')"
            :class="{ 'navlinks__link--active': isUrl(`settings/application`) }"
            class="navlinks__link"
          >
            Application
          </InertiaLink>
        </div>
        <div class="navlinks__item">
          <InertiaLink
            :href="route('settings.users.index')"
            :class="{ 'navlinks__link--active': isUrl(`settings/users`) }"
            class="navlinks__link"
          >
            Users
          </InertiaLink>
        </div>
      </TopbarPanel>
    </topbar>

    <sidebar />

    <div class="content">
      <div class="content__wrapper">
        <NoContent v-if="!settings.data.length" />

        <table
          v-if="settings.data.length"
          class="table"
        >
          <thead>
            <tr>
              <th>Key</th>
              <th>Type</th>
              <th>Value</th>
              <th>Default Value</th>
              <th class="u-talign-r">Last Update</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="setting in settings.data"
              :key="setting.id"
            >
              <td>
                <a href=""
                   @click.prevent="openModal(setting)"
                >{{ setting.key }}</a>
              </td>
              <td>{{ setting.type }}</td>
              <td>{{ setting.value }}</td>
              <td>{{ setting.default_value }}</td>
              <td class="u-talign-r">{{ setting.updated_at | moment }}</td>
              <td class="u-talign-r">
                <div class="button-group">
                  <button
                    v-tippy="{
                      arrow : true,
                      arrowType : 'sharp',
                      placement : 'top',
                      animation : 'shift-away'
                    }"
                    content="Remove"
                    class="button button--icon"
                    @click.prevent="openConfirmModal(setting)"
                  >
                    <i class="icon icon-delete-forever" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Topbar from '@components/Topbar'
import Sidebar from '@components/Sidebar'
import TopbarPanel from '@components/shared/TopbarPanel'
import Dashboard from '@layouts/Dashboard'
import NoContent from '@components/shared/NoContent'
import ApplicationModal from '@components/settings/ApplicationModal'

export default {
  metaInfo () {
    return {
      title: 'Settings | Application',
    }
  },
  components: {
    NoContent,
    TopbarPanel,
    Topbar,
    Sidebar,
  },
  layout: Dashboard,
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openModal (setting = null) {
      this.$store.dispatch('modal/open', {
        modal: ApplicationModal,
        setting,
      })
    },
    async openConfirmModal(material) {
      const response = await this.$store.dispatch('modal/confirm', {
        title: `Are you sure you want to delete ${material.name}`,
        text: 'This item will be deleted immediately. You can\'t undo this action.',
      })

      if (response) {
        this.$inertia.delete(this.route('settings.materials.destroy', material.id))
      }
    },
  },
}
</script>

